import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputsProps } from '../types';
import { CustomCalendar } from 'src/components/CustomCalendar';
import { useTranslation } from 'react-i18next';
import { validateDateOfBirthThreeFields } from 'src/hooks/useForm';
import classNames from 'classnames';

export const FormDateInput: FC<FormInputsProps> = ({ field, defaultValue }) => {
  const { name, title, toShow } = field;
  const { control } = useFormContext();
  const isShowField = toShow && !defaultValue;
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <Controller
        name={name}
        control={control}
        rules={{
          required: { value: toShow, message: 'validation.valueRequired' },
          validate: validateDateOfBirthThreeFields
        }}
        defaultValue={defaultValue}
        render={({ field, fieldState: { error } }) => {
          return (
            <div className={classNames(!isShowField ? 'hidden' : 'w-full')}>
              <CustomCalendar
                defaultValue={defaultValue}
                label={isShowField ? title : ''}
                key={name}
                isMonthsShort={true}
                classNameDropdown="!w-full"
                dateFormat={'YYYY-MM-DD'}
                labelClassName="text-i_label !ml-0 pl-2.5"
                onChange={field.onChange}
                value={field.value}
                placeholderDay={`${t('general.dd')}`}
                placeholderMonth={`${t('general.mm')}`}
                placeholderYear={`${t('general.yyyy')}`}
              />
              {error?.message && (
                <span className="text-map_error text-xs">{t(error?.message)}</span>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};
